/**
 * GovOps permit/case workflow transitions (mirrors sdpanthers-xr-api govopsWorkflow.ts).
 * Same-state updates are always allowed.
 */
const ALLOWED_TRANSITIONS = {
  intake: ['under_review'],
  under_review: ['notice_sent', 'appealed'],
  notice_sent: ['violation_open'],
  violation_open: ['payment_pending', 'appealed'],
  payment_pending: ['payment_received', 'payment_overdue', 'resolved'],
  payment_received: ['resolved', 'closed'],
  payment_overdue: ['payment_received', 'payment_pending', 'resolved'],
  renewal_due: ['renewal_notice_sent', 'expired', 'intake'],
  renewal_notice_sent: ['intake', 'under_review', 'expired'],
  expired: ['intake'],
  resolved: ['closed', 'renewal_due'],
  closed: ['renewal_due'],
  appealed: ['under_review', 'closed'],
};

export function getAllowedNextStatuses(fromStatus) {
  const from = fromStatus || 'intake';
  const next = ALLOWED_TRANSITIONS[from] || [];
  return [from, ...next];
}

export function canTransitionGovOpsStatus(fromStatus, toStatus) {
  if (!toStatus) return false;
  if (fromStatus === toStatus) return true;
  return (ALLOWED_TRANSITIONS[fromStatus] || []).includes(toStatus);
}
